import { Button } from '@liveauctioneers/hammer-ui-core/button';
import styled, { css } from 'styled-components';

import { RouteLink } from '@/components/RouteLinks/RouteLinks';

export { Button as StyledButton };

export const StyledLink = RouteLink;

export const BrandedWrapper = styled.div<{ $brandColor?: string }>`
    & > button {
        ${({ $brandColor }) =>
            $brandColor &&
            css`
                background: ${$brandColor} !important;
                background-color: ${$brandColor} !important;
                border-color: ${$brandColor} !important;
            `}
    }
`;

export const HoverWrapper = styled.div`
    width: 100%;
    display: flex;

    &.countdown {
        margin-bottom: 0 !important;
    }

    @media (max-width: 500px) {
        text-align: center;
    }
`;
